import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { Header } from 'antd/es/layout/layout';
import useAppsMenuConfig from '@Hooks/useAppsMenuConfig';
import { useAppSelector, useRoutePrefix } from '@Hooks/index';
import { ConfigItem } from '@Types/index';
import BaseConfigItems from '@Enum/BaseConfigItems.enum';
import { currentTokenJSONKey } from '@Store/selectors/authSelector';
import { getTbmsParams } from '@Utils/getApiUrl';
import { DarkMode, Notify, AppsPopover } from '../components';
import UserProfileMobile from '../components/mobile/UserProfileMobile';
import MobileSearch from '../components/mobile/MobileSearch';

import { getProfilePagePath } from '../utils';

import styles from './header-application-mobile.module.css';

interface HeaderApplicationMobileProps {
  appsText?: string;
}

const HeaderApplicationMobile: React.FC<HeaderApplicationMobileProps> = ({
  appsText = '',
}) => {
  const configPopoverContent = useAppsMenuConfig();
  const navigate = useNavigate();
  const routePrefix = useRoutePrefix();
  const sessionTokenJSONKey = useAppSelector(currentTokenJSONKey);
  const { tbmsPortalUrl } = getTbmsParams();

  const handleProfileClick = (): void => {
    const profilePagePath = getProfilePagePath(routePrefix);
    navigate(profilePagePath);
  };

  const getRedirectURLToTBMS = async (): Promise<void> => {
    const tokenJSON = sessionStorage.getItem(sessionTokenJSONKey);
    if (tokenJSON) {
      const response = await fetch(tbmsPortalUrl, {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: tokenJSON,
      });

      const result = await response.json();

      if (result && result.status === 'success') {
        window.open(result.returnUrl, '_blank');
      }
    }
  };

  const updatedContentItems = configPopoverContent.map((item: ConfigItem) =>
    item.title === BaseConfigItems.TBMS
      ? {
          ...item,
          onClick: () => {
            getRedirectURLToTBMS();
          },
        }
      : item
  );

  return (
    <Header className={classNames('trojan-mobile-header-app', styles.header)}>
      <div className={styles.headerActionItemsSection}>
        <div className={classNames('mobile-header-apps', styles.headerApps)}>
          <AppsPopover
            configPopoverContent={updatedContentItems}
            appsText={appsText}
          />
        </div>
        <div className={styles.itemsWrapper}>
          <div className={styles.itemsSection}>
            <MobileSearch />
          </div>
          <div className={styles.itemsSection}>
            <DarkMode />
          </div>
          <div className={styles.itemsSection}>
            <Notify />
          </div>
          <div className={styles.itemsSection} onClick={handleProfileClick}>
            <UserProfileMobile />
          </div>
        </div>
      </div>
    </Header>
  );
};

export default HeaderApplicationMobile;
